import { useSystemMessages } from '../../../../context/SystemMessagesContext'
import { XIcon } from '@phosphor-icons/react'
import styles from './TopBanner.module.scss'

const TopBanner = () => {
    const { message, clearMessage } = useSystemMessages()

    if (!message) return null

    const type = message.type || 'info'

    return (
        <div className={`${styles.banner} ${styles[type]}`}>
            {message.leftSide && <div className={styles.leftSide}>{message.leftSide}</div>}

            <span className={`${styles.text} ${styles[type]}`}>{message.content}</span>

            {(message.rightSide || message.dismissible) && (
                <div className={styles.rightSide}>
                    {message.rightSide && (
                        <div className={styles.rightSide}>{message.rightSide}</div>
                    )}
                    {message.dismissible && (
                        <button
                            className={`${styles.dismissButton} ${styles[type]}`}
                            onClick={clearMessage}
                        >
                            <XIcon size={12} weight="bold" />
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}

export default TopBanner
